import { create } from "zustand";
import { ErrorSlice, IErrorSliceTypes } from './slice/error-slice'

export const useSystem = create<IErrorSliceTypes>()((...a) => ({
  ...ErrorSlice(...a),
}));
